<template><div><h1>VUX 服务端渲染</h1>
<p>目前支持 <code>NUXT</code> 渲染，可以参考例子：<a href="https://github.com/nuxt/nuxt.js/tree/dev/examples/with-vux">https://github.com/nuxt/nuxt.js/tree/dev/examples/with-vux</a>。</p>
</div></template><script>
export default {
  head: {"title":"VUX 服务端渲染 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-server-render-support-49.vue?5bcf11f6